<div class="chat-window" id="chat-window">
  <header class="chat-header form--soft">
    <a class="chat-header__button chat-header__list"
       [ngClass]="{'active': isListActive, 'active-link': isListActive}"
       id="chat-list-link"
       data-toggle="tab"
       href="#chat-list"
       (click)="activateList()"
       title="{{'chat.window.list' | translate}}">
      <i class="ico-list"></i>
    </a>
    <div class="chat-header__group" *ngIf="!isScanListActive && !isMessagesActive && isLoggedClient">
      <select class="form-control cursor-pointer" id="group"
              [ngClass]="{'active-group': isGroupActive}"
              (change)="activateGroup($event.target.value)">
        <option *ngIf="!isGroupGenerated" href="javascript:void(0);" disabled [value]="">
          {{'chat.window.group' | translate}}
        </option>
        <option *ngIf="isGroupGenerated" selected >
          {{generatedTitle}}
        </option>
        <option href="javascript:void(0);" [value]="null" *ngIf="canSendToAllVehicles">
          {{'chat.window.all-groups' | translate}}
        </option>
        <option *ngFor="let group of vehicleGroups"
                href="javascript:void(0);"
                [value]="group.id">
          {{group.title}}
        </option>
      </select>
    </div>
    <div class="chat-header__current-chat"
        [ngClass]="{'active': isScanListActive || isMessagesActive,
                    'active-link': isScanListActive || isMessagesActive}"
        *ngIf="isScanListActive || isMessagesActive">
      <nav *ngIf="newChatInfo.driverName || newChatInfo.plateNumber"
           class="current-chat__nav">

        <ng-template #driverDetails>
          <span class="vehicle-plate-number"><span class="vehicle-plateNumber-content">{{newChatInfo.plateNumber}}</span></span><br/>
          <ng-container *ngIf="newChatInfo.driverName">
            <i class="ico-wheel"></i> <strong>{{newChatInfo.driverName}}</strong><br/>
          </ng-container>
          <ng-container *ngIf="newChatInfo.driverLanguage">
            <i *ngIf="newChatInfo.driverLanguage == 'EN'; else otherLanguages" class="flag-icon flag-icon-gb" ></i>
            <ng-template #otherLanguages>
              <i class="flag-icon flag-icon-{{newChatInfo.driverLanguage.toLowerCase()}}"></i>
            </ng-template>
            {{'drivers.list.languages.' + newChatInfo.driverLanguage.toLowerCase() | translate}}
          </ng-container>
        </ng-template>

        <span class="chat-name" [ngbTooltip]="driverDetails">
          <span class="chat-name__plate">{{newChatInfo.plateNumber}}</span>
          <span class="chat-name__driver hidden-lg-down" *ngIf="newChatInfo.driverName"><i class="ico-wheel sz-xxs"></i>{{newChatInfo.driverName}}</span>
          <span class="chat-name__lang" *ngIf="newChatInfo.driverLanguage">
            <i *ngIf="newChatInfo.driverLanguage == 'EN'; else otherLanguages" class="flag-icon sz-xxs flag-icon-gb"></i>
            <ng-template #otherLanguages>
              <i class="flag-icon sz-xxs flag-icon-{{newChatInfo.driverLanguage.toLowerCase()}}"></i>
            </ng-template>
          </span>
        </span>
        <div class="auto-translations" *ngIf="isTranslationActive">
          <input type="checkbox"
                 [(ngModel)]="shouldTranslateMessages"
                 class="graphic-control"
                 id="switchAutoTranslate"
                 (change)="switchAutoTranslate($event)">
          <label for="switchAutoTranslate"
                 title="Switch auto translation on/off">
          </label>
        </div>
        <a class="chat-header__button"
           *ngIf="isMessagesActive"
           data-toggle="tab"
           href="#scan-list"
           (click)="activateScanList()">
           <i class="ico-paperclip"></i>
        </a>
        <a class="chat-header__button"
           *ngIf="isScanListActive"
           data-toggle="tab"
           href="#chat-messages"
           (click)="activateMessages()">
           <i class="ico-comment"></i>
        </a>
      </nav>
    </div>
    <a class="chat-header__button chat-header__close" href="javascript:void(0)"
       (click)="closeChat()">
       <i class="ico-close"></i>
     </a>
  </header>
  <div class="chat__main tab-content">
    <app-chat-list
      (openNewChat)="openChatForEvent($event)"
      (openDocs)="openDocsForEvent($event)"
      class="tab-pane chat-list"
      [ngClass]="{'active': isListActive}"
      id="chat-list">
    </app-chat-list>
    <app-global-message
      class="tab-pane chat-messages"
      [ngClass]="{'active': isGroupActive}"
      id="chat-group"
      [fileUri]="fileUri"
      [group]="selectedGroup">
    </app-global-message>
    <app-chat-messages
      [chatInfo]="newChatInfo"
      [fileUri]="fileUri"
      class="tab-pane chat-messages"
      [ngClass]="{'active': isMessagesActive}"
      id="chat-messages">
    </app-chat-messages>
    <app-scan-list
      [scanListInfo]="newChatInfo"
      class="tab-pane chat-list"
      [ngClass]="{'active': isScanListActive}"
      id="scan-list">
    </app-scan-list>
  </div>
</div>
